/**
 * @ngdoc service
 * @name BB.BBAdminDashboard.httptracker:HttpTrackerService
 *
 * @description
 * Tracks calls made via the halclient for debugging purposes
 */
class HttpTrackerService {
    constructor() {
        this.httpLogs = [];
        this.tracking = true;
        this.trackingLimit = 100;
    }

    /***
     * @ngdoc method
     * @name enable
     * @methodOf BB.BBAdminDashboard.httptracker:HttpTrackerService
     * @description Allow tracking of http calls from the halclient
     */
    enable() {
        this.tracking = true;
    }

    /***
     * @ngdoc method
     * @name enable
     * @methodOf BB.BBAdminDashboard.httptracker:HttpTrackerService
     * @description Prevent tracking of http calls from the halclient
     * Existing data will remain but will not cotinue to keep tracking
     */
    disable() {
        this.tracking = false;
    }

    /***
     * @ngdoc method
     * @name setTrackingLimit
     * @methodOf BB.BBAdminDashboard.httptracker:HttpTrackerService
     * @description restricts the amount of data recorded by this services
     * @param {Number} newLimit - The amount of data to be recorded by this service
     */
    setTrackingLimit(newLimit) {
        this.trackingLimit = newLimit;
        this.trimTracker();
    }
    
    /***
     * @ngdoc method
     * @name success
     * @methodOf BB.BBAdminDashboard.httptracker:HttpTrackerService
     * @description Stores a successful network call
     * @param {Object} request - An object representing the network call
     */
    success({method, url, headers, data, result, stack}) {

        if (this.tracking) {
            // TODO - also store this in the session store
            this.httpLogs.push({
                type: 'success',
                datetime: moment(),
                timestamp: moment().unix(),
                method,
                url,
                headers,
                data,
                result,
                stack,
                status: result.status
            });

            this.trimTracker();
        }
    }

    /***
     * @ngdoc method
     * @name error
     * @methodOf BB.BBAdminDashboard.httptracker:HttpTrackerService
     * @description Stores a erroneous network call
     * @param {Object} request - An object representing the network call
     */
    error({method, url, headers, data, result, stack}) {

        if (this.tracking) {
            // TODO - also store this in the session store
            this.httpLogs.push({
                type: 'error',
                datetime: moment(),
                timestamp: moment().unix(),
                method,
                url,
                headers,
                data,
                result,
                stack,
                status: result.status
            });

            this.trimTracker();
        }
    }

    /***
     * @ngdoc method
     * @name trimTracker
     * @methodOf BB.BBAdminDashboard.httptracker:HttpTrackerService
     * @description Removes data being recorded to keep to the limit. 
     * The services keeps a record of latest network request
     */
    trimTracker() {
        if (this.tracking && this.httpLogs.length > this.trackingLimit) {
            const startIndex = this.httpLogs.length - this.trackingLimit;
            this.httpLogs = this.httpLogs.slice(startIndex, this.httpLogs.length);
        }
    }
}

const HttpTrackerServiceInstance = new HttpTrackerService();

export default HttpTrackerServiceInstance;